import { render, staticRenderFns } from "./NewCuentasbancarias.vue?vue&type=template&id=46a5f753&scoped=true&"
import script from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
export * from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
import style0 from "./NewCuentasbancarias.vue?vue&type=style&index=0&id=46a5f753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5f753",
  null
  
)

export default component.exports